import { isArray } from "highcharts";
import { debounce } from "lodash";
import { useEffect, useMemo, useState } from "react";
import { SearchTypes, useVenueSearch } from "../../hooks/useVenueSearch";

export function useVenues() {
  const [searchText , setSearchTerm] = useState<string>("");
  const { isLoading, venuesList} = useVenueSearch(searchText , SearchTypes.VENUE_NAME, undefined, true)

  const handleChange = (txt:string) => {
    setSearchTerm(txt);
  };

  const setSearchText = useMemo(() => {
    return debounce(handleChange, 300);
  }, []);

  useEffect(() => {
    return () => {
      setSearchText.cancel();
    };
  });


  return { venues: isArray(venuesList) ? venuesList : [], setSearchText, isLoading , searchText }

}
